<template>
  <div class="page">
    <!-- 头部 start -->
    <Head :tabIndex="1"></Head>
    <!-- 头部 end -->
    <div class="more">
      <span class="more-left">About US</span>
    <!--  <div class="more-right hidden-xs-only">
        <span>more</span>
        <img class="more-icon" src="../../static/home/youjiantou.png">
      </div> -->
    </div>
    <!-- About US start -->
    <img class="video" src="../../static/home/bg2.png">
    <p class="video-text">{{content}}</p>
    <!-- About US end -->
    <div class="enterprise-list">
      <img src="../../static/home/bg11.png">
      <img src="../../static/home/bg12.png">
    </div>
    <div class="TopLogistics">© 2021 TE EXPRESS Powered by TE EXPRESS</div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        content: ""
      }
    },
    mounted() {
      document.title = 'About Us-TE EXPRESS';
      this.getArticleDetail();
    },
    methods: {
      // 获取关于我们信息
      getArticleDetail() {
        this.$axios({
          method: 'post',
          url: this.$host + this.$api.getArticleDetail,
          headers: {
            lang: 'en'
          },
          data: {
            id: 17
          }
        }).then(res => {
          if (res.data.code == 1) {
            this.content = res.data.data.synopsis;
          }
          // this.SuggestionsType = res.data.data.types;
          console.log(res);
        })
      },
    }

  }
</script>

<style scoped="scoped">
  .page {
    width: 100%;
    font-size: 12px;
  }

  @media only screen and (min-width:1200px) {
    .more {
      height: 47px;
      width: 1200px;
      margin: 30px auto 0;
      display: flex;
      justify-content: space-between;
    }

    .more-left {
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 47px;
      color: #333333;
      opacity: 1;
    }

    .more-right {
      display: flex;
      align-items: center;
    }

    .more-right span {
      font-size: 28px;
      font-weight: 400;
      font-family: Microsoft YaHei;
      color: #666666;
      margin-right: 10px;
    }

    .more-icon {
      margin-top: 5px;
      width: 12px;
      height: 16px;
    }

    .video {
      display: block;
      width: 1200px;
      margin: 32px auto 0;
    }

    .video-text {
      margin: 32px auto 0;
      width: 1200px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 56px;
      color: #666666;
      opacity: 1;
    }

    .enterprise-list {
      max-width: 1200px;
      margin: 20px auto 0;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .enterprise-list img {
      width: 686px;
      height: 360px;
      margin-bottom: 29px;
    }

    .TopLogistics {
      margin: 130px auto;
      text-align: center;
      height: 28px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 28px;
      color: #9EA7B7;
      opacity: 1;
    }
  }

  @media only screen and (min-width:768px) and (max-width: 1199px) {
    .more {
      height: 47px;
      width: 768px;
      margin: 30px auto 0;
      display: flex;
      justify-content: space-between;
    }

    .more-left {
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 47px;
      color: #333333;
      opacity: 1;
    }

    .more-right {
      display: flex;
      align-items: center;
    }

    .more-right span {
      font-size: 28px;
      font-weight: 400;
      font-family: Microsoft YaHei;
      color: #666666;
      margin-right: 10px;
    }

    .more-icon {
      margin-top: 5px;
      width: 12px;
      height: 16px;
    }

    .video {
      display: block;
      width: 768px;
      margin: 32px auto 0;
    }

    .video-text {
      margin: 32px auto 0;
      width: 768px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 56px;
      color: #666666;
      opacity: 1;
    }

    .enterprise-list {
      max-width: 768px;
      margin: 20px auto 0;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .enterprise-list img {
      width: 686px;
      height: 360px;
      margin-bottom: 29px;
    }

    .TopLogistics {
      margin: 130px auto;
      text-align: center;
      height: 28px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 28px;
      color: #9EA7B7;
      opacity: 1;
    }
  }

  @media only screen and (max-width: 767px) {
    .more {
      width: 90%;
      margin: 0.3rem auto 0;
      display: flex;
      justify-content: space-between;
    }

    .more-left {
      font-size: 0.36rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 0.47rem;
      color: #333333;
      opacity: 1;
    }

    .more-right {
      display: flex;
      align-items: center;
    }

    .more-right span {
      font-size: 0.28rem;
      font-weight: 400;
      font-family: Microsoft YaHei;
      color: #666666;
      margin-right: 0.1rem;
    }

    .more-icon {
      margin-top: 0.05rem;
      width: 0.12rem;
      height: 0.16rem;
    }

    .video {
      display: block;
      width: 90%;
      margin: 0.32rem auto 0;
    }

    .video-text {
      margin: 0.32rem auto 0;
      width: 90%;
      font-size: 0.28rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 0.36rem;
      color: #666666;
      opacity: 1;
    }

    .enterprise-list {
      width: 90%;
      margin: 0.2rem auto;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .enterprise-list img {
      width: 100%;
      height: 3.6rem;
      margin-bottom: 0.29rem;
    }

    .TopLogistics {
      margin: 1.3rem auto;
      text-align: center;
      font-size: 0.2rem;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0.28rem;
      color: #9EA7B7;
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/about.vue